import { gql } from '@apollo/client';

const DELETE_ASSIGNMENT = gql`
  mutation deleteAssignment($data: AssignmentDeleteInput!) {
    deleteAssignment(data: $data)
  }
`;

export default DELETE_ASSIGNMENT;
